module.exports = __webpack_public_path__ + "static/media/img-exhibition-tablet.2856d392.jpg";